var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMobile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 86,
    height: 86,
    viewBox: "0 0 86 86",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1318_4390)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M51.0897 46.8693C50.3157 46.8693 49.6886 47.4967 49.6886 48.2704V69.1782H14.3413V33.8296H30.0967C30.8707 33.8296 31.4978 33.2023 31.4978 32.4285C31.4978 31.6547 30.8707 31.0274 30.0967 31.0274H14.3413V25.0927C14.3413 22.629 16.3456 20.6247 18.8093 20.6247H24.3053C25.0793 20.6247 25.7064 19.9974 25.7064 19.2236C25.7064 18.4498 25.0793 17.8225 24.3053 17.8225H18.8093C14.8004 17.8225 11.5391 21.0839 11.5391 25.0927V77.9151C11.5391 81.9239 14.8004 85.1853 18.8093 85.1853H45.2205C49.2294 85.1853 52.4908 81.9239 52.4908 77.9151V48.2704C52.4908 47.4967 51.8636 46.8693 51.0897 46.8693ZM45.2205 82.3833H18.8093C16.3456 82.3833 14.3413 80.379 14.3413 77.9153V71.9806H49.6886V77.9153C49.6886 80.379 47.6842 82.3833 45.2205 82.3833Z",
    fill: "#157B7D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.0896 0.185547C38.6284 0.185547 28.4902 8.36647 28.4902 18.4221C28.4902 27.0267 35.8391 34.3694 46.123 36.2175C46.258 38.7724 45.3161 41.2951 43.5091 43.1193C43.111 43.521 42.9937 44.1227 43.2113 44.6447C43.4289 45.1666 43.9389 45.5066 44.5044 45.5066C50.0412 45.5066 54.8023 41.5869 55.983 36.2306C66.305 34.4039 73.6889 27.0476 73.6889 18.4222C73.6891 8.36647 63.551 0.185547 51.0896 0.185547ZM54.5533 33.6193C53.8255 33.7198 53.299 34.3654 53.3467 35.0983C52.8269 38.3672 50.5818 41.0141 47.6358 42.1311C48.7268 39.9857 49.1602 37.5258 48.829 35.0899C48.8721 34.3606 48.3474 33.7193 47.6221 33.6189C38.1602 32.3112 31.2926 25.92 31.2926 18.4222C31.2924 9.9116 40.1735 2.98774 51.0896 2.98774C62.0056 2.98774 70.8869 9.9116 70.8869 18.4221C70.8869 25.9213 64.0176 32.3127 54.5533 33.6193Z",
    fill: "#157B7D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.6171 16.9275C42.793 16.9275 42.1226 17.598 42.1226 18.422C42.1226 19.246 42.793 19.9165 43.6171 19.9165C44.4411 19.9165 45.1116 19.246 45.1116 18.422C45.1116 17.598 44.4411 16.9275 43.6171 16.9275Z",
    fill: "#157B7D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.5624 16.9275C57.7383 16.9275 57.0679 17.598 57.0679 18.422C57.0679 19.246 57.7383 19.9165 58.5624 19.9165C59.3864 19.9165 60.0569 19.246 60.0569 18.422C60.0569 17.598 59.3864 16.9275 58.5624 16.9275Z",
    fill: "#157B7D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.0897 16.9275C50.2657 16.9275 49.5952 17.598 49.5952 18.422C49.5952 19.246 50.2657 19.9165 51.0897 19.9165C51.9138 19.9165 52.5842 19.246 52.5842 18.422C52.5842 17.598 51.9138 16.9275 51.0897 16.9275Z",
    fill: "#157B7D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1318_4390"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 85,
    height: 85,
    fill: "white",
    transform: "translate(0.114258 0.185547)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobile);
export default __webpack_public_path__ + "static/media/mobile.328465d616844e7643868601d0746ffc.svg";
export { ForwardRef as ReactComponent };